import { faPen, faTrash, faQuestionCircle, faUserCheck } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import dayjs from 'dayjs';
import React, { useContext, useEffect, useState } from 'react';
import { AuthContext } from '../Auth/AuthContext'
import { Table, Button, Row, Col, Form } from 'react-bootstrap';
import { useHistory } from 'react-router-dom'
import { LanguageContext } from '../Language/LanguageContext';
import { TablePagination, Loading } from '../Library';
import { listVisitorReport } from '../Network/Visitor';
import { AlertModalContext } from '../Library/AlertModalContext'
import { ModalContext } from '../Library/ModalContext';
import { NotifyContext } from '../Library/Notify'
import "./VisitorOrganizeCar.css"
import axios from 'axios'
import { wtc5214,visitor8082 } from '../Network/Config'
import DatePicker from "react-datepicker";

function VisitorOrganizeCar(props) {
    const alertModal = useContext(AlertModalContext)
    const modal = useContext(ModalContext)
    const langCx = useContext(LanguageContext)
    const notifyCx = useContext(NotifyContext);
    const lang = langCx.lang.visitor
    const history = useHistory();
    const [isLoading, setIsLoading] = useState(false)
    const [isError, setError] = useState(false);
    const [page, setPage] = useState(1)
    const size = 10
    const [count, setCount] = useState(0)
    const [carData, setCarData] = useState([])
    const [carIDSelected, setCarIDSelected] = useState('')
    const [userFirstName, setuserFirstName] = useState()
    const [userLastName, setUserLastName] = useState()
    const [userCar, setUserCar] = useState([])
    const [startDate, setStartDate] = useState(null)
    const [endDate, setEndDate] = useState(null) 

    useEffect( async ()=>{
        try {
            setIsLoading(true)
            const formData = new FormData();
            formData.append('company_name', props.company);
            if(startDate == null || endDate == null){
                formData.append('start_date', dayjs().format("YYYY-MM-DD"));
                formData.append('end_date', dayjs().add(1,'day').format("YYYY-MM-DD"));
            }else{
                formData.append('start_date', dayjs(startDate).format("YYYY-MM-DD"));
                formData.append('end_date', dayjs(endDate).format("YYYY-MM-DD"));
                
            }
            const responseData1 = await axios.post(visitor8082+'/visitor/api/v1/getcar_idbyapp', formData, {timeout:500});
            console.log(responseData1.data.data)
            setCarData(responseData1.data.data)
            setIsLoading(false)
        } catch (e) {
            console.error(e);
            setIsLoading(false)
        }
    }, [10, props,startDate,endDate])
    
    useEffect(()=>{
        console.log("userFirstName : ", userFirstName)
        console.log("userLastName : ", userLastName)
    },[userFirstName, userLastName])

    useEffect(()=>{
        console.log(userCar)
    },[userCar])

    const addUserByCar = () => {
        modal.setComponent(
            <div className='modal-body-user'>
                <Form
                    onSubmit={(e)=>{
                        e.preventDefault();
                        addUserToApi();
                    }}
                    >
                        <Form.Group>
                            <Form.Label>{'ชื่อจริง'}</Form.Label>
                            <Form.Control
                            placeholder="ชื่อจริง"
                            value={userFirstName}
                            isInvalid={isError && !userFirstName}
                            onChange={(e)=>setuserFirstName(e.target.value)}
                            />
                        </Form.Group>
                        <Form.Group>
                            <Form.Label>{'นามสกุล'}</Form.Label>
                            <Form.Control
                            placeholder="นามสกุล"
                            value={userLastName}
                            isInvalid={isError && !userLastName}
                            onChange={(e)=>setUserLastName(e.target.value)}
                            />
                        </Form.Group>
                        <hr/>
                        <Form.Group>
                            <Button type="submit" style={{marginTop: 30}}>{'บันทึกทะเบียนรถ'}</Button>
                        </Form.Group>
                    </Form>
            </div>
        )
        modal.setHeader('รถทะเบียน '+carIDSelected)
        modal.setDark(false)
        modal.setShow(true)
    }

    const addUserToApi = () => {
        /*
        if(!userFirstName , !userLastName){
            notifyCx.showNotify(lang.not_complete, lang.not_complete_desc, 1)
            setError(true);
            return;
        }
        */
        console.log(userFirstName)
    }

    const VisitorOrganizeCarItem = ({ carID, carType, carCompany, onEditClick, onDeleteClick }) => {
        return(
            <tr className='tr-body-car' onClick={()=>getCarUser(carID)}>
                <td>{carID}</td>
                <td>{carType}</td>
                <td>{carCompany}</td>
            </tr>
        )
    }

    const ShowUserCar = ({firstName ,lastName ,index}) =>{
        return(
            <tr className='tr-body-user'>
                <td>{index+1}</td>
                <td>{firstName}</td>
                <td>{lastName}</td>
            </tr>
        )
    }

    const getCarUser = async (carID) => {
        setCarIDSelected(carID)
        try {
            const formData = new FormData();
            formData.append('company_name', props.company);
            formData.append('car_id', carID);
            const responseData = await axios.post(visitor8082+'/visitor/api/v1/getuser_bycarid', formData, {timeout:500});
            setUserCar(responseData.data.data)
            console.log(responseData.data.data)
        } catch (e) {
            console.error(e);
        }
    }

    return(
        <div id="visitor-report">
            { isLoading ? <Loading/> : null }
            <div className="button-container">
                <div style={{display:'flex', justifyContent:'space-between'}}>
                    <div>{'จัดการรถเข้าออก'}</div>
                    <div style={{justifyContent:'flex-end'}}>
                        <Button onClick={()=>history.push("/visitor_organize_car/create")}>เพิ่มทะเบียนรถ</Button>
                    </div>
                </div>
            </div>
            <div style={{paddingTop:10}}>
            <Row>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่เริ่มต้น'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={startDate}
                                onChange={(date)=>{
                                    setStartDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่เริ่มต้น'}
                                maxDate={new Date()}
                                />
                                </div>
                            </Form.Group>
                </Col>
                <Col md={6} lg={6}>
                            <Form.Group>
                                <Form.Label>{'วันที่สิ้นสุด'}</Form.Label>
                                <div>
                                <DatePicker 
                                selected={endDate}
                                onChange={(date)=>{
                                    setEndDate(date)
                                }}
                                className="form-control" 
                                dateFormat="d MMMM yyyy"
                                placeholderText={'วันที่สิ้นสุด'}
                                maxDate={new Date()}
                                minDate={startDate}
                                />
                                </div>
                            </Form.Group>
                </Col>
            </Row>
            </div>

            <Row>
                <Col md={8} xl={8}>
                    <div className='table-container'>
                        <Table hover>
                            <thead>
                                <tr className='table-tr'>
                                    <th>{'ทะเบียนรถ'}</th>
                                    <th>{'ประเภทรถ'}</th>
                                    <th>{'บริษัท'}</th>
                                </tr>
                            </thead>
                            <tbody>
                                { carData.map((item, key) =>
                                <VisitorOrganizeCarItem
                                    key={key}
                                    carID={item.getcar_id}
                                    carType={item.car_type}
                                    carCompany={item.company}
                                />)}
                            </tbody>
                        </Table>
                    </div>
                </Col>

                <Col md={4} xl={4}>
                <div className='table-container'>
                    <Table hover>
                            <thead>
                                <tr className='table-tr'>
                                    <th colSpan={2}>{'รายชื่อพนักงานขับรถ ' + carIDSelected}</th>
                                    <th>
                                        <Button disabled={carIDSelected?false:true} onClick={()=>history.push("/visitor_organize_car/adduser/"+carIDSelected)}>เพิ่มคนบนทะเบียนรถ</Button>
                                    </th>
                                </tr>
                            </thead>
                            <tbody>
                                {
                                    userCar.map((item, key)=>
                                        <ShowUserCar
                                            key={key}
                                            index={key}
                                            firstName={item.firstname}
                                            lastName={item.lastname}
                                        />
                                    )
                                }
                            </tbody>
                        </Table>
                </div>
                </Col>
            </Row>
        </div>
    )
}

export default VisitorOrganizeCar;
